import { Component, OnInit, Input } from '@angular/core';
import { SalaryService } from '../../../services/salary.service';
import { AlertService } from '../../../services/alert.service';
import { Salary } from '../../../models/salaries/salary';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-salary-history',
	templateUrl: './salary-history.component.html',
	styleUrls: ['./salary-history.component.css']
})
export class SalaryHistoryComponent implements OnInit {

	salaryHistory: Salary[] = [];

	constructor(
		private _salaryService: SalaryService,
		private _activatedRoute: ActivatedRoute,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		let id = this._activatedRoute.snapshot.params['id'];
		if(id != undefined){
			this._salaryService.getUserSalaryList(id).subscribe(
				result => {
					if(result.length != undefined){
						this.salaryHistory = result;
						this.processSalaryHistory()				
					}
					else{
						this._alertService.showInfo("A problem occured while processing your request.");
					}
				}
			)
		}
	}

	private processSalaryHistory(){
		if(this.salaryHistory.length < 1)
			return;
		
		//set first item to 0
		this.salaryHistory[0].percentDifference = 0;
		
		for(let i = 1; i < this.salaryHistory.length; i++){
			//increase = NEW_AMOUNT - ORIGINAL_AMOUNT; 
			let increase = this.salaryHistory[i].amount - this.salaryHistory[i-1].amount;
			
			//percent difference = INCREASE / ORIGINAL_AMOUNT * 100
			//a negative number means a decrease 
			this.salaryHistory[i].percentDifference = Math.ceil(increase / this.salaryHistory[i-1].amount * 100);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/salaries/salary-history/salary-history.component.ts